<template>
    <div>
        <Chart :cdata="cdata" />
    </div>
</template>

<script>
import Chart from './chart.vue';
import { universalQueryResult } from '../../api/holdMy';
export default {
    data() {
        return {
            cdata: {
                category: [
                    "停机",
                    "待机",
                    "在线"
                ],
                rateData: []
            },
            drawTiming: null,
            workingMachineQty:0
        };
    },
    components: {
        Chart,
    },
    mounted() {
        this.drawTimingFn();
        // this.setData();

    },
    beforeDestroy() {
        clearInterval(this.drawTiming);
    },
    methods: {
        drawTimingFn() {
            this.getUniversalQueryResult();
            this.drawTiming = setInterval(() => {
                this.getUniversalQueryResult();
            }, 6000*10);
        },

        // 根据自己的业务情况修改
        async setData() {
            // 清空轮询数据
            this.cdata.rateData = [];
            var dateDiff = Math.round((new Date().getTime() - new Date('2021-11-04 00:00:00').getTime())/(1000*60),0);//时间差的分钟数
            var data = [this.workingMachineQty,69,388]
            this.cdata.rateData = data;
        },

        getUniversalQueryResult() {
            universalQueryResult("大数据入网和在线机械").then(res => {
                if (res.result == 0) {
                    this.workingMachineQty = res.rows[0].workingMachine;
                    this.setData();
                }
            }).catch(error => {
                console.log(error);
            })
        },
    }
};
</script>

<style lang="scss" scoped></style>